import React from 'react'
import Increment from './Increment'
const App = () => {
  return (
   <Increment/>
  )
}

export default App